import { Account } from '@api/core';
import { EnumTranslation, getInvalidEnumTranslation, getSortedTranslations } from '@shared/enums/shared/enums.utils';
import { assertNever } from '@shared/utils/assertions';
import { EnvType, getEnvType } from '@shared/utils/envs';

export namespace BusinessEntityEnum {
  const values: readonly Account.BusinessEntityEnum[] = [
    Account.BusinessEntityEnum.Sandbox1,
    Account.BusinessEntityEnum.Sandbox2,
    Account.BusinessEntityEnum.Inc,
    Account.BusinessEntityEnum.Bermuda,
    Account.BusinessEntityEnum.Brazil,
  ];

  export function getValuesByEnvType() {
    const envType = getEnvType();

    const valuesMap: { [key in EnvType]: Account.BusinessEntityEnum[] } = {
      Sandbox: [Account.BusinessEntityEnum.Sandbox1, Account.BusinessEntityEnum.Sandbox2],
      Inc: [Account.BusinessEntityEnum.Inc],
      Bermuda: [Account.BusinessEntityEnum.Bermuda, Account.BusinessEntityEnum.Brazil],
    };

    return getSortedTranslations(valuesMap[envType], toEnumTranslation);
  }

  export function translate(val: Account.BusinessEntityEnum): string {
    return toEnumTranslation(val).description;
  }

  export function getTranslatedOrderedValues(toTranslateAndOrder?: readonly Account.BusinessEntityEnum[]) {
    return getSortedTranslations(toTranslateAndOrder || values, toEnumTranslation);
  }

  export function toEnumTranslation(val: Account.BusinessEntityEnum): EnumTranslation {
    switch (val) {
      case 'SANDBOX1':
        return {
          description: 'Sandbox1',
          order: 0,
        };
      case 'SANDBOX2':
        return {
          description: 'Sandbox2',
          order: 1,
        };
      case 'INC':
        return {
          description: 'Inc',
          order: 2,
        };
      case 'BERMUDA':
        return {
          description: 'Bermuda',
          order: 3,
        };
      case 'BRAZIL':
        return {
          description: 'Brazil',
          order: 4,
        };
      default:
        return assertNever<EnumTranslation>(val, getInvalidEnumTranslation(val));
    }
  }
}
